import React from 'react';
import { Text, ScrollView, StyleSheet } from 'react-native';
import { useTheme } from 'react-native-paper';
import PropTypes from 'prop-types';

export default function About({ lang, pageContent }) {
  const { colors } = useTheme();
  const styles = StyleSheet.create({
    link: { color: colors.accent, fontWeight: 'bold' },
  });

  return (
    <ScrollView>
      <Text>{pageContent[0]}</Text>
      <Text>{'\n'}</Text>
      {lang === 'en' ? (
        <Text>
          The crop water use values ​​were simulated using CROPWAT 8.0 model.
          The CROPWAT model and its simulation processes are described in a
          manuscript (in preparation) entitled “Estimation of typical crop water
          use for sustainable agricultural water management in the Arequipa
          region, Peru”. The researchers used information for each of soils in
          the Majes Irrigation, the City of Arequipa, and the Colca Valley,
          Peru, local crop coefficient for typical crops, short reference
          evapotranspiration simulated by using the Penman-Monteith equation,
          and climate data including daily rainfall and temperature that were
          measured by SENAMHI and were provided by AQP-Clima (
          <Text
            style={styles.link}
            onPress={() =>
              Linking.openURL(
                'https://mygeohub.org/groups/nexus_swm/arequipa_climate'
              )
            }
          >
            https://mygeohub.org/groups/nexus_swm/arequipa_climate
          </Text>
          ).
        </Text>
      ) : lang === 'es' ? (
        <Text>
          Los valores de uso de agua de cultivo se simularon utilizando el
          modelo CROPWAT 8.0. El modelo CROPWAT y sus procesos de simulación se
          describen en un manuscrito (en preparación) titulado "Estimación del
          uso típico del agua de cultivo para la gestión sostenible del agua
          agrícola en la región de Arequipa, Perú". Los investigadores
          utilizaron información para cada uno de los suelos en el Riego Majes,
          la Ciudad de Arequipa y el Valle del Colca, Perú, coeficiente de
          cultivo local para cultivos típicos, evapotranspiración de referencia
          corta simulada mediante la ecuación de Penman-Monteith, y datos
          climáticos que incluyen precipitaciones diarias y temperatura que
          fueron medidos por el SENAMHI y proporcionados por AQP-Clima (
          <Text
            style={styles.link}
            onPress={() =>
              Linking.openURL(
                'https://mygeohub.org/groups/nexus_swm/arequipa_climate'
              )
            }
          >
            https://mygeohub.org/groups/nexus_swm/arequipa_climate
          </Text>
          ).
        </Text>
      ) : (
        <Text>TRANSLATE</Text>
      )}
      <Text>{'\n'}</Text>
      {lang === 'en' ? (
        <Text>
          This tool was developed by the Sustainable Water Management team of
          the Nexus Institute of Arequipa (
          <Text
            style={styles.link}
            onPress={() =>
              Linking.openURL(
                'https://www.agry.purdue.edu/hydrology/projects/NEXUS-SWM/es/'
              )
            }
          >
            https://www.agry.purdue.edu/hydrology/projects/NEXUS-SWM/es/
          </Text>
          ). Contributors include Jingqiu Chen, Benjamin G. Hancock, Katy E.
          Mazer, José Pinto, Dharmendra Saraswat, Bernard A. Engel, and Laura C.
          Bowling.
        </Text>
      ) : lang === 'es' ? (
        <Text>
          Esta herramienta fue desarrollada por el equipo de Gestión Sostentible
          del Agua del Instituto Nexus de Arequipa (
          <Text
            style={styles.link}
            onPress={() =>
              Linking.openURL(
                'https://www.agry.purdue.edu/hydrology/projects/NEXUS-SWM/es/'
              )
            }
          >
            https://www.agry.purdue.edu/hydrology/projects/NEXUS-SWM/es/
          </Text>
          ). Los colaboradores incluyen a Jingqiu Chen, Benjamin G. Hancock,
          Katy E. Mazer, José Pinto, Dharmendra Saraswat, Bernard A. Engel y
          Laura C. Bowling.
        </Text>
      ) : (
        <Text>TRANSLATE</Text>
      )}
      <Text>{'\n'}</Text>
      <Text>{pageContent[1]}</Text>
    </ScrollView>
  );
}

About.propTypes = {
  pageContent: PropTypes.array,
};
